var render, staticRenderFns
import script from "./product-categories-dropdown-items.vue?vue&type=script&lang=ts"
export * from "./product-categories-dropdown-items.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports